import { authActionTypes } from 'Types/AuthTypes';

export const setTempSignUpPass = (payload: string | undefined) => ({
  type: authActionTypes.SET_TEMP_SIGNUP_PASS,
  payload,
});

export const clearAuthData = () => ({
  type: authActionTypes.CLEAR_DATA,
});
